export default __webpack_public_path__ + "static/philippines-7b6696435d088a1960ec1096ae2de22f.svg";